<template>
	<div>
      <div class="date-wrapper">
        <FilterChipButtons
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
        />
        <div v-if="filterModalIsVisible">
          <FilterModal
              :filterModalIsVisible="filterModalIsVisible"
              :currentModalFilter="currentModalFilter"
              :currentModalLabel="currentModalLabel"
              :selectedChips="selectedChips"
              :filters="filters"
              :dateError="date.error"
              :dateOption="date.option"
              :dateRange="date.selectedRange"
              @closeModal="closeModal"
              @applySelection="applySelection"
              @setItem="setItem"
          />
        </div>
      </div>
			<v-skeleton-loader
				v-if="isLoadingSpeakers || sortLoading"
				v-bind="attrs"
				max-width="555"
				width="100%"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>
      <div v-else>
        <NewsFeedEmpty
            class="mt-2"
            v-if="!speakers.length"
            title="No speakers found."
            description="Check back later."
        />
        <div v-else style="width: 100%">
          <div v-for="speaker in speakers" :key="speaker.speaker_id">
            <EventSpeakerCard :speaker="speaker" />
          </div>
          <div
              class="d-flex my-9 justify-center home-page__pagination"
              v-if="!isLoadingSpeakers"
          >
            <Pagination
                :page="filters.page"
                :pageCount="+this.sessionSpeakersPageCount"
                v-on:pageChange="onPageChange"
            />
          </div>
        </div>
      </div>

	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SpeakerCard from '@/components/Event/SpeakerCard'
import Filter from '@/mixins/Filter'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import Pagination from '@/components/Pagination.vue'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard.vue'
import Dwh from "@/mixins/Dwh";
import NewsFeedEmpty from "@/components/Post/NewsFeedEmpty.vue";

export default {
	name: 'SpeakersPage',

	components: {
    NewsFeedEmpty,
		EventSpeakerCard,
		Pagination,
		FilterModal,
		FilterChipButtons,
		SpeakerCard,
	},
	mixins: [Filter, Dwh],

	props: {
		name: {
			type: String,
			default: 'Speakers',
		},
	},
	mounted() {
		this.setPageTitle(this.name)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},

	methods: {
		...mapActions('event', ['getAllSessionsSpeaker']),
		...mapActions('app', ['setPageTitle']),
	},

	async created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
      await this.sortingLists();
			this.getAllSessionsSpeaker(this.requestQuery)
      this.sendTrigger({
        category: 'Speakers',
        action: 'view_speakers_list_session',
        title: 'Speakers',
        module: 'Events',
        id2: this.$route.params.id,
      })
		}
	},

	computed: {
		...mapGetters('event', [
			'sessionSpeakers',
			'isLoadingSpeakers',
			'sessionSpeakersError',
			'sessionSpeakersPageCount',
		]),
    ...mapGetters('app', ['sortLoading']),

		speakers() {
			return this.sessionSpeakers
				.flatMap((group) => group.speakersList || [])
				.filter((item) => item.block_name === 'speakerInfo')
				.map((item) => item.block_data)
		},
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
		}
	},
}
</script>

<style lang="scss">
.partners-page {
	background: #f1f1f1 !important;
}
</style>
